<template>
  <div>
    <vx-card>
      <div class="flex mb-3 justify-between">
        <h3>{{$t('Products')}}</h3>
        <vs-button v-if="$store.state.AppActiveUser.userRole === 'merchant' && orderData.status === 'created'" @click="addNewProduct('Add New Product')" color="primary" class="py-2 px-3">{{ $t('Add more products') }}</vs-button>
      </div>
      <shipblu-table
      :sst="true"
        multiple
        v-model="selected"
        :data="orderProducts"
      >
        <template slot="thead">
          <shipblu-th>{{$t('SKU')}}</shipblu-th>
          <shipblu-th>{{$t('Product Name')}}</shipblu-th>
          <shipblu-th>{{$t('Description')}}</shipblu-th>
          <shipblu-th>{{$t('Quantity')}}</shipblu-th>
          <shipblu-th>{{$t('Size')}}</shipblu-th>
          <shipblu-th>{{$t('Color')}}</shipblu-th>
          <shipblu-th>{{$t('Flags')}}</shipblu-th>
          <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'merchant'">{{$t('Actions')}}</shipblu-th>
        </template>

        <template slot-scope="{ data }">
          <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <shipblu-td :data="data[indextr].sku">
              {{ data[indextr].product ? data[indextr].product.sku : '' }}
            </shipblu-td>

            <shipblu-td :data="data[indextr].productName">
              {{ data[indextr].product ? data[indextr].product.name : '' }}
            </shipblu-td>

            <shipblu-td :data="data[indextr].description">
              {{ data[indextr].product ? data[indextr].product.description : '' }}
            </shipblu-td>

            <shipblu-td :data="data[indextr].description">
              {{ data[indextr].product ? data[indextr].quantity : '' }}
            </shipblu-td>

            <shipblu-td :data="data[indextr].size">
              {{ data[indextr].product ? data[indextr].product.size : '' }}
            </shipblu-td>

              <shipblu-td :data="data[indextr].color">
              <div class="color-container h-6 w-3/4">
                <div class="w-full h-full" :style="`background-color:${ data[indextr].product ? data[indextr].product.color : 'black'}`"></div>
              </div>
            </shipblu-td>

            <shipblu-td :data="data[indextr].flags">
              <p v-for="(item, index) in data[indextr].flags" :key="index">
                {{ item.name }}
              </p>
            </shipblu-td>

            <shipblu-td v-if="$store.state.AppActiveUser.userRole === 'merchant'">
              <span @click="addNewProduct('Edit Product', data[indextr])" 
                :disabled="!orderInfoEditable" :class="orderData.status === 'created' ? 'text-primary' : 'disabled'">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="h-6 w-6"
                  class="mr-2"
                />
              </span>
              <span v-if="orderProducts.length > 1" @click="deleteProduct(data[indextr])" 
                :disabled="!orderInfoEditable" :class="orderData.status === 'created' ? 'text-danger' : 'disabled'">
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="h-6 w-6"
                />
              </span>
            </shipblu-td>
          </shipblu-tr>
        </template>
      </shipblu-table>
    </vx-card>
    <add-order :orderProducts="orderProducts" :orderProduct="orderProduct" :type="type" :orderModal="orderModal" :order="order" @orderModal="orderModal = $event" @loadOrder="loadOrder"></add-order>
    
    <div class="grid grid-cols-3 gap-4">
      <div class="lg:col-span-2 col-span-3 clearfix">
        <!-- PACKAGE -->
        <vx-card class="mt-4 p-4">
          <div class="flex mb-3 justify-between">
            <h3>{{$t('Packaging')}}</h3>
            <vs-button v-if="$store.state.AppActiveUser.userRole === 'merchant' && orderData.status === 'created'" @click="addPackage('Add')" color="primary" class="py-2 px-3">{{ $t('Add packaging') }}</vs-button>
          </div>

          <shipblu-table
            :sst="true"
            multiple
            v-model="selected"
            :data="orderPackages"
          >
            <template slot="thead">
              <shipblu-th>{{$t('Package')}}</shipblu-th>
              <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'merchant'">{{$t('Actions')}}</shipblu-th>
            </template>

            <template slot-scope="{ data }">
              <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <shipblu-td :data="data[indextr].requestID">
                  {{ data[indextr].package_size.name }}
                </shipblu-td>
                <shipblu-td v-if="$store.state.AppActiveUser.userRole === 'merchant'">
                  <span @click="addPackage('Edit', data[indextr])" 
                    :disabled="!orderInfoEditable" :class="orderData.status === 'created' ? 'text-primary' : 'disabled'">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="h-6 w-6"
                      class="mr-2"
                    />
                  </span>
                  <span @click="deleteProduct(data[indextr])" 
                    :disabled="!orderInfoEditable" :class="orderData.status === 'created' ? 'text-danger' : 'disabled'">
                    <feather-icon
                      icon="Trash2Icon"
                      svgClasses="h-6 w-6"
                    />
                  </span>
                </shipblu-td>
              </shipblu-tr>
            </template>
          </shipblu-table>
        </vx-card>
        <add-order-packages :packageObj="packageObj" :packageModal="packageModal" @loadOrder="loadOrder" :type="packageType" @packageModal="packageModal = $event"/>
        <vx-card class="mt-4 p-4">
          <div class="flex justify-between items-center mt-6">
            <h3 class="">{{$t('Shipping Info')}}</h3>
            <div class="flex items-center justify-center sm:mt-0">
              <div v-for="(providerItem, index) in providers" :key="index">
                <label v-if="orderData.customer.address.shipping_provider_metadata.hasOwnProperty(providerItem.name)" @click="checkedItem(providerItem, providers)" class="prompt cursor-pointer" :class="index === 0 ? 'mr-4' : ''">
                  <input disabled v-model="provider" :class="provider === providerItem.name ? 'checked' : ''" :value="providerItem.name" type="radio" />
                  <span class="py-2 px-4 rounded capitalize text-sm">{{ $t(providerItem.name.replace('b', 'B')) }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="items-end grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
            <div class="col-span-1">
              <vs-input :disabled="!orderInfoEditable" :class="orderData.customer.full_name ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" v-validate="'required'" :label-placeholder="$t('Full Name') + '*'" name="full name" v-model="orderData.customer.full_name"/>
              <span class="text-danger text-sm" v-show="errors.has('full name')">{{ errors.first('full name') }}</span>
            </div>
            <div class="col-span-1">
              <vs-input :disabled="!orderInfoEditable" :class="orderData.customer.phone ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" v-validate="{ required: true, regex: /(^01[0,1,2,5]\d{8}$|^\u0660\u0661[\u0660,\u0661,\u0662,\u0665][\u0660-\u0669]{8}$)/ }" :label-placeholder="$t('Phone Number') + '*'" name="phone number" v-model="orderData.customer.phone"/>
              <span class="text-danger text-sm" v-show="errors.has('phone number')">{{ errors.first('phone number') }}</span>
            </div>
          </div>
          <div class="grid grid-cols-1 sm:gap-4 gap-2">
            <div class="col-span-1">
              <vs-input name="additional phone number" v-validate="{ regex: /(^0\d*\d{8}$|^\u0660[\u0660-\u0669]*[\u0660-\u0669]{8}$)/ }" :disabled="!orderInfoEditable" :class="orderData.customer.secondary_phone ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" :label-placeholder="$t('Additional Phone Number')" v-model="orderData.customer.secondary_phone"/>
              <span class="text-danger text-sm" v-show="errors.has('additional phone number')">{{ errors.first('additional phone number') }}</span>
            </div>
          </div>
          <div class="grid grid-cols-1">
            <div class="col-span-1">
              <vs-input :disabled="!orderInfoEditable" :class="orderData.customer.address.line_1 ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" v-validate="'required'" name="address 1" :label-placeholder="$t('Customer Address 1') + '*'" v-model="orderData.customer.address.line_1"/>
              <span class="text-danger text-sm" v-show="errors.has('address 1')">{{ errors.first('address 1') }}</span>
            </div>
            <div class="col-span-1">
              <vs-input :disabled="!orderInfoEditable" :class="orderData.customer.address.line_2 ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" v-validate="'required'" name="address 2" :label-placeholder="$t('Customer Address 2') + '*'" v-model="orderData.customer.address.line_2"/>
              <span class="text-danger text-sm" v-show="errors.has('address 2')">{{ errors.first('address 2') }}</span>
            </div>
          </div>
          <template>
            <div class="grid grid-cols-1 gap-4 mt-4" v-if="provider === 'shipblu'">
              <div class="col-span-1">
                <v-select autocomplete="nofill" :disabled="!orderInfoEditable" :options="governorates" :class="governorate ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" name="governorate" label="name" item-text="name"
                  v-model="governorate" item-value="id" return-object v-on:input="governorate ? loadCities(`${governorate.id}`) : zones = [], zone = '', cities = [], city = ''"
                  :placeholder="$t('Governorate')" v-validate="'required'"></v-select>
                <span class="text-danger text-sm" v-show="errors.has('governorate')">{{ errors.first('governorate') }}</span>
              </div>
              <div class="col-span-1">
                <v-select autocomplete="nofill" :disabled="!orderInfoEditable" :options="cities" :class="city ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" name="city" label="name" item-text="name"
                  v-model="city" item-value="id" return-object v-on:input="city ? loadZones(`${city.id}`) : zones = [], zone = ''"
                  :placeholder="$t('City')" v-validate="'required'"></v-select>
                <span class="text-danger text-sm" v-show="errors.has('city')">{{ errors.first('city') }}</span>
              </div>
              <div class="col-span-1">
                <v-select autocomplete="nofill" :disabled="!orderInfoEditable" :options="zones" :class="zone ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" name="zone" label="name" item-text="name"
                  v-model="zone" item-value="id" return-object :placeholder="$t('Zone')" v-validate="'required'"></v-select>
                <span class="text-danger text-sm" v-show="errors.has('zone')">{{ errors.first('zone') }}</span>
              </div>
              <div class="sm:flex items-center justify-between">
                <div class="flex items-center sm:justify-start justify-center">
                  <img src="@/assets/images/logo/w3w.svg" alt="">
                  <p class="leading-tight text-darkgray font-medium mx-1 text-xs text-lightgray">{{ $t('(Optional)') }}</p>
                  <a target="blank" href="https://what3words.com/tricycle.hotel.jeering" class="material-icons-outlined text-primary text-2xl cursor-pointer">help_center</a>
                </div>
                <div class="sm:m-0 m-auto sm:mt-0 mt-3">
                  <what3words-autosuggest clip_to_country="EG" :api_key="W3W_API_KEY">
                    <input :disabled="!orderInfoEditable" class="w-68 input-on" v-model="orderData.customer.address.what3words" name="w3w" id="what3words"/>
                  </what3words-autosuggest>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 mt-4" v-else>
              <div class="col-span-1">
                <vs-input :disabled="!orderInfoEditable" :class="governorate ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" v-validate="'required'" :label-placeholder="$t('Governorate') + '*'" name="governorate" v-model="governorate"/>
                <span class="text-danger text-sm" v-show="errors.has('governorate')">{{ errors.first('governorate') }}</span>
              </div>
              <div class="col-span-1">
                <vs-input :disabled="!orderInfoEditable" :class="city ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" v-validate="'required'" :label-placeholder="$t('City') + '*'" name="city" v-model="city"/>
                <span class="text-danger text-sm" v-show="errors.has('city')">{{ errors.first('city') }}</span>
              </div>
            </div>
          </template>
          <div class="grid grid-cols-2 sm:gap-4 gap-2">
            <div class="col-span-1">
              <vs-input :disabled="!orderInfoEditable" :class="orderData.merchant_reference ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" name="merchant reference" :label-placeholder="$t('Merchant Reference') + '*'" v-model="orderData.merchant_reference"/>
            </div>
            <div class="col-span-1 self-end">
              <v-select :disabled="$store.state.AppActiveUser.userRole === 'fc-operations-supervisor' || !orderInfoEditable" :class="orderData.flags && orderData.flags.length !== 0 ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" 
                multiple autocomplete="nofill" label="name" :name="`flags`" v-model="orderData.flags" :placeholder="$t('Flags')" :options="productFlags"/>
            </div>
          </div>
          <div class="grid grid-cols-1 mt-2">
            <div class="col-span-1">
              <vs-input :disabled="!orderInfoEditable" :class="orderData.notes ? 'input-customer-info-filled' : ''" class="w-full input-customer-info" name="notes" :label-placeholder="$t('Notes') + '*'" v-model="orderData.notes"/>
            </div>
          </div>
          <div class="flex justify-end gap-4 mt-6" v-if="$store.state.AppActiveUser.userRole === 'merchant'">
            <button v-if="!orderInfoEditable && (orderData.status === 'created' || orderData.status === 'confirmed_to_ship')" @click="orderInfoEditable = true" class="active-btn btn px-6">{{ $t('Edit') }}</button>
            <button v-if="orderInfoEditable" @click="closeEdit" class="btn disable-btn px-6">{{ $t('Cancel') }}</button>
            <button v-if="orderInfoEditable" @click="updateOrder" class="active-btn btn px-6">{{ $t('Save') }}</button>
          </div>
        </vx-card>
      </div>
      <div class="lg:col-span-1 col-span-3">
        <order-tracking :trackings="trackings" :orderData="orderData" @loadOrder="loadOrder" @loadTrackings="loadTrackings"/>
      </div>
    </div>
  </div>
</template>
<script>
import {sendFulfillmentRequest, sendRequest} from '../../../../http/axios/requestHelper.js'
import common  from '@/assets/utils/common'
import i18nData from '../../../../i18n/i18nData.js'
import vSelect from 'vue-select'
import AddOrder from '../components/AddOrder.vue'
import ShipbluTable from '../../../../layouts/components/ShipBluTable.vue'
import ShipbluTr from '../../../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../../../layouts/components/ShipBluTd.vue'
import OrderTracking from '../components/OrderTracking.vue'
import AddOrderPackages from '../../../fcOperationsSupervisor/components/AddOrderPackages.vue'

export default {
  data () {
    return {
      W3W_API_KEY: process.env.VUE_APP_WHAT3WORDS_API_KEY,
      selected: [],
      order: {},
      orderInfoEditable: false,
      orderPackagesEditable: false,
      editable: false,
      orderModal: false,
      type: 'Add New Product',
      orderProduct: {},
      trackings: [],
      orderProducts: [],
      productFlags: [],
      fulfillmentCenters: [],
      stockProduct: {},
      stockRequest: {},
      deleteData: {},
      orderData: {
        customer: {
          address: {
            shipping_provider_metadata: {
              other: {
                governorate: '',
                city: ''
              }
            }
          }
        }
      },
      providers: [
        {
          name: 'shipblu',
          checked: true
        },
        {
          name: 'other',
          checked: false
        }
      ],
      city: '',
      zone: {},
      governorate: '',
      zones: [],
      cities: [],
      governorates: [],
      packageModal: false,
      packageType: 'Add',
      orderPackages: [],
      packageSizes: [],
      provider: '',
      packageObj: {}
    }
  },
  components: {
    AddOrder,
    vSelect,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    OrderTracking,
    AddOrderPackages
  },
  watch: {
    provider () {
      if (this.orderInfoEditable) {
        this.city = ''
        this.governorate = ''
      }
    }
  },
  methods: {
    addPackage (type, data) {
      this.packageModal = true
      this.packageType = type
      this.packageObj = data
    },
    checkedItem (element, array) {
      array.forEach(item => {
        if (item.name === element.name) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
    },
    addNewProduct (type, data) {
      this.type = type
      if (type === 'Add New Product') {
        this.stockProduct = Object.assign({}, {})
      } else {
        this.orderProduct = data
        this.orderProduct.product.optionalLabel = `SKU: ${data.product.sku} . ${data.product.current_inventory_level} available`
      }
      this.orderModal = true
    },
    updateOrder () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let orderInfoData = {}
          let providerobj = {}
          const customerZone = {
            id: this.zone.id,
            name: this.zone.name
          }
          const customerCity = {
            id: this.city.id,
            name: this.city.name
          }
          const customerGovernorate = {
            id: this.governorate.id,
            name: this.governorate.name
          }
          if (this.provider === 'shipblu') {
            orderInfoData.delivery = {}
            providerobj = {
              order: {
                id: this.orderData.customer.address.shipping_provider_metadata.shipblu.order.id,
                tracking_number: this.orderData.customer.address.shipping_provider_metadata.shipblu.order.tracking_number,
                zone: customerZone,
                city: customerCity,
                governorate: customerGovernorate,
                what3words: this.orderData.customer.address.what3words
              }
            }
          } else {
            providerobj = {
              city: this.city,
              governorate: this.governorate
            }
          }
          orderInfoData = {
            ...orderInfoData,
            flags: this.orderData.flags.map(item => item.id),
            merchant_reference: this.orderData.merchant_reference,
            notes: this.orderData.notes,
            customer: {
              full_name: this.orderData.customer.full_name,
              phone: this.orderData.customer.phone,
              secondary_phone: this.orderData.customer.secondary_phone,
              email: this.orderData.customer.email,
              address: {
                line_1: this.orderData.customer.address.line_1,
                line_2: this.orderData.customer.address.line_2,
                shipping_provider_metadata: {}
              }
            }
          }
          orderInfoData.customer.address.shipping_provider_metadata[this.provider] = this.provider
          orderInfoData.customer.address.shipping_provider_metadata[this.provider] = providerobj
          sendFulfillmentRequest(false, this, `api/v1/fc/orders/${this.$route.params.type}/${this.$route.params.orderID}/`, 'patch', orderInfoData, true,
            () => {
              this.closeEdit()
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
            }
          )
        }
      })
    },
    closeEdit () {
      this.orderInfoEditable = false
      this.orderPackagesEditable = false
      this.loadOrder()
    },
    deleteProduct (data) {
      this.deleteData = data
      this.$vs.dialog({
        color: 'danger',
        title: i18nData[this.$i18n.locale]['Confirm'],
        text: i18nData[this.$i18n.locale]['Are you sure to delete?'],
        accept: this.confirmDelete
      })
    },
    confirmDelete () {
      sendFulfillmentRequest(false, this, `api/v1/fc/orders/${this.$route.params.orderID}/${this.deleteData.package_size ? 'packages' : 'products'}/${this.deleteData.id}/`, 'delete', null, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Item'] + i18nData[this.$i18n.locale][' has been deleted successfully!'],
            position: 'top-center'
          })
          this.loadOrder()
        }
      )
    },
    loadOrder () {
      sendFulfillmentRequest(false, this, `api/v1/fc/orders/${this.$route.params.type}/${this.$route.params.orderID}/`, 'get', null, true,
        (response) => {
          this.orderData = response.data
          this.orderProducts = response.data.products
          this.orderPackages = response.data.packages
          this.provider = this.orderData.customer.address.shipping_provider_metadata.shipblu ? 'shipblu' : 'other'
          this.loadGovernorates()
          if (this.orderData.customer.address.shipping_provider_metadata) {
            this.city = this.orderData.customer.address.shipping_provider_metadata.shipblu ? this.orderData.customer.address.shipping_provider_metadata.shipblu.order.city : this.orderData.customer.address.shipping_provider_metadata.other.city
            this.governorate = this.orderData.customer.address.shipping_provider_metadata.shipblu ? this.orderData.customer.address.shipping_provider_metadata.shipblu.order.governorate : this.orderData.customer.address.shipping_provider_metadata.other.governorate
            this.zone = this.orderData.customer.address.shipping_provider_metadata.shipblu ? this.orderData.customer.address.shipping_provider_metadata.shipblu.order.zone : {}
            if (this.$store.state.AppActiveUser.userRole === 'merchant') {
              this.loadProductFlags()
            }
          }
        }
      )
    },
    loadPackages () {
      sendFulfillmentRequest(false, this, 'api/v1/fc/package-sizes/', 'get', null, true,
        (response) => {
          this.packageSizes = response.data
        })
    },
    loadProductFlags () {
      sendFulfillmentRequest(false, this, 'api/v1/fc/flags/', 'get', null, true,
        (response) => {
          this.productFlags = response.data.results
        }
      )
    },
    loadFulfillmentCenters () {
      sendFulfillmentRequest(false, this, 'api/v1/fc/fulfillment-centers/', 'get', null, true,
        (response) => {
          this.fulfillmentCenters = response.data.results
        }
      )
    },
    loadTrackings () {
      sendFulfillmentRequest(false, this, `api/v1/fc/orders/${this.$route.params.orderID}/tracking/`, 'get', null, true,
        (response) => {
          this.trackings = response.data.results
        }
      )
    },
    formatTime (time) {
      let hr = time.split(':')[0]
      const min = time.split(':')[1]
      const ampm = hr >= 12 ? i18nData[this.$i18n.locale]['pm'] : i18nData[this.$i18n.locale]['am']
      hr = hr > 12 ? hr -= 12 : hr
      return `${hr  }:${  min  }${ampm}`
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    },
    loadGovernorates () {
      sendRequest(false, this, 'api/v1/governorates/', 'get', null, true, 
        (response) => {
          this.governorates = response.data
          this.governorates = this.governorates.filter(item => item.id !== 20)
          if (this.city.id) {
            this.loadCities(this.governorate.id)
          }
        }
      )
    },
    loadCities (governorateID) {
      const url = 'api/v1/governorates/'
      const type = '/cities/'
      sendRequest(false, this, `${url}${governorateID}${type}`, 'get', null, true, 
        (response) => {
          this.cities = response.data
          this.cities = this.cities.filter(item => item.id !== 91)
          if (this.city) {
            this.loadZones(this.city.id)
          }
        }
      )
    },
    loadZones (cityID) {
      const url = 'api/v1/cities/'
      const type = '/zones/'
      sendRequest(false, this, `${url}${cityID}${type}`, 'get', null, true, 
        (response) => {
          this.zones = response.data
          this.zones = this.zones.filter(item => item.id !== 284)
          this.loadAvailablePudos(cityID)
        }
      )
    }
  },
  created () {
    this.loadPackages()
    this.loadOrder()
    this.loadTrackings()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table{
  display: none;
}
.disabled {
  color: #C5CBD0;
  pointer-events: none;
}
.vx-timeline {
  margin-left: 0.5rem;
  padding-left: 40px;
  border-left: 2px dotted #e5e8eb;
  li {
    position: relative;

    .timeline-icon {
      position: absolute;
      top: 0;
      left: -3.2rem !important;
      border-radius: 50%;
      padding: 0px;
      padding: 0.3rem !important;
      padding-bottom: 0.4rem;
    }
  }
}
.product-order-status, .activity-e-status {
  margin-left: -30px;
}
.color-container {
  border: 1px solid #000;
  border-radius: 7px;
  padding: 2px;
  margin: auto !important;
  div {
    border-radius: 5px;
  }
}
</style>